import {
  Skeleton as ChakraSkeleton,
  type SkeletonProps as ChakraSkeletonProps,
} from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraSkeletonProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return <ChakraSkeleton ref={ref} {...props} />
})
